import Apptimize from '@apptimize/apptimize-web-sdk'

/**
 * Recursively walks through the nested defaultFeatureFlags
 * object and updates boolean values using Apptimize's feature
 * flag values. Also populates alert banner values if present.
 *
 * @param {Record<string, any>} flagsObject - The object containing default feature flags.
 * @param {string} [pathPrefix=''] - Used to build the full path for nested keys (i.e. accountDetails.isNotificationsEnabled)
 * @returns {Record<string, any>} The updated feature flags object with Apptimize values.
 */

const getFeatureFlagsFromApptimize = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  flagsObject: Record<string, any>,
  pathPrefix = ''
) => {
  Object.keys(flagsObject).forEach((key) => {
    const value = flagsObject[key]
    const path = pathPrefix ? `${pathPrefix}.${key}` : key

    // Checks if each value is a boolean, and updates only the boolean fields.
    if (typeof value === 'boolean') {
      const result = Apptimize.isFeatureFlagEnabled(path)
      if (typeof result === 'boolean') {
        // eslint-disable-next-line no-param-reassign
        flagsObject[key] = result
      }

      // flagsObject[key] = Apptimize.isFeatureFlagEnabled(path)
    } else if (typeof value === 'object' && value !== null) {
      getFeatureFlagsFromApptimize(value, path)
    }
  })

  // pulls the array of strings from the alertBanner and assigns it
  Apptimize.track('Apptimize Initialized')
  if (flagsObject.alertBanner?.showAlertBanner === true) {
    const alertBannerStringArray =
      Apptimize.getStringArray('alertBannerValues') ?? []
    const banner = flagsObject.alertBanner

    const [alertLink, alertLinkText, alertMessage, alertTitle, alertSeverity] =
      alertBannerStringArray

    banner.alertLink = alertLink
    banner.alertLinkText = alertLinkText
    banner.alertMessage = alertMessage
    banner.alertTitle = alertTitle
    banner.alertSeverity = alertSeverity
  }

  return flagsObject
}

export default getFeatureFlagsFromApptimize
